export default __webpack_public_path__ + "static/media/shape-group.6adaf12f.svg";